import type { SVGProps } from 'react';
const SvgArrowForwardIos = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#arrow_forward_ios_svg__a)">
      <path
        fill="currentColor"
        d="M5.88 4.12 13.76 12l-7.88 7.88L8 22l10-10L8 2 5.88 4.12Z"
      />
    </g>
    <defs>
      <clipPath id="arrow_forward_ios_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgArrowForwardIos;
